// Iter 590 — Bordir Multi-Operator: helper bersama.
import axios from "axios";
import { notify } from "./modal_center";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const enc = encodeURIComponent;
export const errMsg = (e) => { const d = e.response?.data?.detail; return typeof d === "string" ? d : "Silakan coba lagi."; };
export const ST = { assigned: "Ditugaskan", in_progress: "Dikerjakan", done: "Selesai", cancelled: "Dibatalkan" };
export const HO_ST = { pending: "Menunggu diterima", received: "Diterima", disputed: "Ada selisih", resolved: "Selisih selesai" };
export const post = (url, body, params) => axios.post(`${API}${url}`, body ?? null, { params, withCredentials: true });
export const posLabel = (t) => t.positions.map(p => `${p.label} (${p.points} titik)`).join(", ");

export async function run(fn, okTitle, after) {
  try { await fn(); if (okTitle) notify.success({ title: okTitle }); }
  catch (e) { notify.error({ title: "Gagal", message: errMsg(e) }); }
  if (after) await after();
}

export function TaskLine({ t, showOrder = false }) {
  return (
    <span className="bt-line">
      {showOrder && <><b>SPK {t.order_number}</b> · {t.product_name} · </>}
      <b>{t.operator_name}</b> · {t.bundle_label} · {posLabel(t)} ·{" "}
      <span data-testid={`bordir-task-progress-${t.id}`}>{t.pcs_done}/{t.pcs_assigned} pcs</span>
      {" "}· {(t.pcs_done * t.points_per_pcs)}/{t.pcs_assigned * t.points_per_pcs} satuan titik ·{" "}
      <span className={`bt-st bt-${t.status}`}>{ST[t.status] || t.status}</span>
      {t.is_rework && <span className="bt-rework"> · Perbaikan</span>}
    </span>
  );
}
